import * as React from 'react';
import { Dropdown, DropdownObject, DropdownProps } from '@inmoment/the-kitchen';

export interface Props {
  propName: string;
  interfaceName: string;
  data: DropdownObject[];
  elementToDisableScroll?: DropdownProps['elementsToDisableScroll'];
  onSelect: (value: DropdownObject) => void;
  value?: DropdownProps['value'];
}

export const PropDownControl: React.FC<Props> = (props) => {
  const { propName, onSelect, elementToDisableScroll, data, value } = props;

  return (
    <span>
      <Dropdown
        label={propName}
        onValueChange={({ selected }) => onSelect(selected as DropdownObject)}
        color="orca"
        data={data}
        value={value}
        elementsToDisableScroll={elementToDisableScroll}
        placeholder={propName}
      />
      <br />
    </span>
  );
};
